import { useTranslation } from 'react-i18next';
import { Badge } from './Badge';
import { parseFreeTimeSlot } from '@/lib/schedule';

/** Prominently displays an AI proposal's "when" (e.g. "🕐 Monday · 20:00–21:30")
 * instead of the raw, lowercase, untranslated free_time_slot string
 * ("friday 08:00–08:15") users were missing — small muted text easy to skim
 * past. Falls back to the raw string if it doesn't match the expected shape,
 * so the day/time is never silently hidden. */
export function ProposalSlotBadge({ slot }: { slot: string }) {
  const { t } = useTranslation();
  const parsed = parseFreeTimeSlot(slot);
  const label = parsed
    ? `${t(`student_timetable.days_full.${parsed.day}`, { defaultValue: parsed.day })} · ${parsed.start}–${parsed.end}`
    : slot;
  return <Badge label={`🕐 ${label}`} variant="success" />;
}
